import React from 'react';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import { Typography, Button } from '@common-ui/ui';
import columbiaModeEnum from '../../enums/columbiaModeEnum';
import { useSelector } from 'react-redux';
import { AddCircle } from '@mui/icons-material';
import beginUpload from '../../utils/beginUpload';

export default function WorkItemNotification({ display }) {
  const { mode } = useSelector((state) => state.columbia);
  return (
    display &&
    mode === columbiaModeEnum.INTERACTIVE && (
      <div className="workItem workItem__notification">
        <div className="workItem_imageDetails workItem__notification__details">
          <div className="workItem__notification__content">
            <InsertPhotoIcon fontSize="large" sx={{ zIndex: 2, color: '#006faa' }} />
          </div>
          <Typography variant="h6" sx={{ color: '#006faa' }}>
            You have not added any images yet.
          </Typography>
          <Typography sx={{ color: '#006faa !important' }}>
            Click the button below to Upload Images. To access the image library, go to Manage
            Images.
          </Typography>
          <div>
            <Button
              sx={{ borderRadius: '0.5rem', position: 'relative' }}
              size="large"
              startIcon={<AddCircle />}
              onClick={beginUpload}
            >
              Begin Upload
            </Button>
          </div>
          <Typography variant="caption" sx={{ marginTop: '25px', color: '#006faa' }}>
            After an upload, it may take a few moments for your image to appear. If they do not,
            please try refreshing the page.
          </Typography>
        </div>
      </div>
    )
  );
}
